import Router from 'vue-router'
import Vue from 'vue'

const router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'lloyds-landing',
      component: () => import('./landing.vue'),
      alias: ['/grant-finder']
    },
    {
      path: '/lloyds-grants-eligibility',
      name: 'lloyds-form',
      component: () => import('./grants/grantsForm.vue')
    },
    {
      path: '/lloyds-grants-matches',
      name: 'lloyds-grants',
      component: () => import('./grants/grants.vue')
    },
    {
      path: '/lloyds-grants-matches/:id',
      name: 'lloyds-grants-overlay',
      component: () => import('./grants/grant.vue')
    },
    {
      path: '*',
      redirect: { path: '/' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const routeName = to.name || ''
  document.title =
    routeName
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ') + ' - Swoop Group'

  next()
})

export default router
